import React, { useContext } from "react";
import "./Works.css";
import Oculus from "../../img/oculus.png";
import Google from "../../img/google.png";
import Meta from "../../img/meta.png";
import Vive from "../../img/vive.png";
import Facebook from "../../img/Facebook.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "#b0d12a" : "" }}>Camera VR</span>
          <span>Brands & Providers</span>
          <spane style={{ color: darkMode ? "white" : "" }}>
            Now only a few companies provide virtual reality cameras.
            <br />
            There may be others, but I think these are some really good brands,
            <br />
            You can see more clearly on their respective websites.
            <br />
            So, enjoy the beauty of the virtual reality world.
          </spane>
          <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div initial={{ rotate: 45 }} whileInView={{ rotate: 0 }} viewport={{ margin: "-40px" }} transition={{ duration: 3.5, type: "spring" }} className="w-mainCircle">
          <div className="w-secCircle">
            <img src={Oculus} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Google} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Meta} alt="" />
          </div>{" "}
          <div className="w-secCircle">
            <img src={Vive} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Facebook} alt="" />
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
